import { asyncPipe } from '@helo/utils'
import { StateCreator } from 'zustand'

import {
  UpdateUserSettingsInput,
  UserSettingsQuery,
} from '../../../gql/graphql'
import { UserSettingsSliceActions } from './userSettingsSlice.actions'

export type UserSettingsSlice = {
  userSettings: {
    settings: UserSettingsQuery['userSettings']
    retrieveUserSettings: () => Promise<UserSettingsQuery['userSettings']>
    updateUserSettings: (
      settings: UpdateUserSettingsInput,
    ) => Promise<UserSettingsQuery['userSettings']>
  }
}

// Slice
export const userSettingsSlice: StateCreator<
  UserSettingsSlice,
  [],
  [],
  UserSettingsSlice
> = (set, get) => ({
  userSettings: {
    settings: null,
    retrieveUserSettings: () =>
      asyncPipe(
        get(),
        UserSettingsSliceActions.loadUserSettings(),
        set,
        () => get().userSettings.settings,
      ),
    updateUserSettings: (settings: UpdateUserSettingsInput) =>
      asyncPipe(
        get(),
        UserSettingsSliceActions.updateUserSettings(settings),
        UserSettingsSliceActions.loadUserSettings(),
        set,
        get,
        store => store.userSettings.settings,
      ),
  },
})
